import { createFileRoute } from '@tanstack/react-router';

import { AdminNotificationsPage } from '@/features/organization-admin';

export const Route = createFileRoute('/admin/notifications')({
  component: AdminNotificationsPage,
});
